
import { Component, Vue, Prop } from "vue-property-decorator";
import CadDialog from "@/components/CadDialog.vue";

@Component({
	components: {
		CadDialog,
	},
})
export default class ArticleCadPreview extends Vue {
	@Prop()
	private articleId!: number;
	@Prop()
	private articleLastChange!: any;
	@Prop()
	private width!: string;
	@Prop()
	private height!: string;
	@Prop()
	private readonly!: boolean;
	private cadDialog: boolean = false;

	private onThumbnailClicked(event: PointerEvent) {
		this.cadDialog = true;
	}

	private getThumbnailUrl() {
		return (
			process.env.VUE_APP_erpUrl +
			`article/getthumbnail?id=${this.articleId}&time=${this.articleLastChange}`
		);
	}
}
